import React, { useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import TrialCta from '../TrialCta';
import LandingFooter from '../LandingFooter';
import { guideNavItems } from './guideNav';
import '../LandingPage.css';
import './Guide.css';

const HelpLayout: React.FC = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="guide-page">
      <header className="landing-nav">
        <div className="landing-nav-inner container">
          <Link to="/" className="landing-nav-brand" aria-label="GallopAI home">
            <img src="/white_wide_logo_noBG.png" alt="GallopAI" className="landing-nav-logo" />
          </Link>
          <nav className="landing-nav-links" aria-label="Site sections">
            <a href="/#how-it-works" className="landing-nav-link">
              Modes
            </a>
            <a href="/#features" className="landing-nav-link">
              Features
            </a>
            <a href="/#pricing" className="landing-nav-link">
              Pricing
            </a>
          </nav>
          <div className="landing-nav-actions">
            <button
              type="button"
              className="guide-sidebar-open-btn"
              aria-expanded={mobileNavOpen}
              aria-controls="guide-sidebar-nav"
              aria-label={mobileNavOpen ? 'Close guide topics' : 'Open guide topics'}
              onClick={() => setMobileNavOpen((o) => !o)}
            >
              {mobileNavOpen ? <X size={20} aria-hidden /> : <Menu size={20} aria-hidden />}
            </button>
            <Link to="/login" className="btn btn-signin">
              Sign In
            </Link>
            <TrialCta className="btn-compact-trial">Subscribe</TrialCta>
          </div>
        </div>
      </header>

      <div className="guide-layout-main-area">
        <div className="guide-layout-body container">
          <aside
            id="guide-sidebar-nav"
            className={`guide-sidebar${mobileNavOpen ? ' is-open' : ''}`}
          >
            <button type="button" className="guide-sidebar-close" onClick={() => setMobileNavOpen(false)}>
              Close
            </button>
            <p className="guide-sidebar-title">Topics</p>
            <nav aria-label="User guide sections">
              <ul className="guide-nav">
                {guideNavItems.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={`/guide/${item.path}`}
                      className={({ isActive }) => (isActive ? 'active' : undefined)}
                      onClick={() => setMobileNavOpen(false)}
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
            <div className="guide-sidebar-extras">
              <Link to="/faq" onClick={() => setMobileNavOpen(false)}>
                FAQ
              </Link>
              <Link to="/contact" onClick={() => setMobileNavOpen(false)}>
                Contact
              </Link>
            </div>
          </aside>

          <main className="guide-main">
            <Outlet />
          </main>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default HelpLayout;
